import { Vue, Trait } from 'av-ts'

@Trait 
export class VueUtils extends Vue {
  setFocus(elm: Vue | Element | Vue[] | Element[]): void {
    this.$nextTick(() => (elm as HTMLInputElement).focus())
  }
}